import { takeEvery, select } from 'redux-saga/effects'
import { LOCATION_CHANGE } from 'connected-react-router'

import { getIdentityActiveRoleName } from 'store/entities/identity/selectors'
import { getViewOrganization } from 'store/entities/organizations/selectors'
import { SUPER_ADMIN } from 'app/constants/roles'
import { googlePageview, googleTrack } from '../googleAnalytics'

export function* handleLocationChangeForAnalytics({ payload }) {
  try {
    const { pathname } = payload
    const roleName = yield select(getIdentityActiveRoleName)
    const organization = yield select(getViewOrganization)
    const people = organization && organization.get && organization.get('name')
    if (roleName !== SUPER_ADMIN) {
      googlePageview(pathname)
      googleTrack('PageView', 'pageview', pathname, people)
    }
  } catch (error) {
    console.log('Analytics Page view fail', error)
  }
}

export default function* pageviewSaga() {
  yield takeEvery(LOCATION_CHANGE, handleLocationChangeForAnalytics)
}
